import * as React from 'react'

import { observer } from 'mobx-react'

import Sidepanel from 'modules/core/components/Sidepanel'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import settingsEvents, {
  SettingsEventsProvider,
} from 'modules/attendance/store/collections/settingsEvents'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import Content from './_Content'

interface Props {
  selectedSetting: AttendanceSetting
  attendanceSettings: AttendanceSetting[]
  open: boolean
  onChange: (newSetting: AttendanceSetting) => void
  onClose: () => void
}

const SettingsPanel = ({ selectedSetting, attendanceSettings, open, onChange, onClose }: Props) => {
  const settingIds = attendanceSettings.map((setting) => setting.attributes.id)

  const { loading } = useAsyncData(() => {
    if (!open) return Promise.resolve()

    if (settingsEvents.length) settingsEvents.reset([])

    return settingsEvents.fetch({ data: { employees_setting_ids: settingIds } })
  }, [open])

  return (
    <SettingsEventsProvider collection={settingsEvents}>
      <Sidepanel
        title={i18n.t('time_tracking.settings.versions.sidepanel.title')}
        open={open}
        onClose={onClose}
        closeLabel={i18n.t('common.close')}
      >
        <Content
          selectedSetting={selectedSetting}
          attendanceSettings={attendanceSettings}
          onChange={onChange}
          loading={loading}
        />
      </Sidepanel>
    </SettingsEventsProvider>
  )
}

export default observer(SettingsPanel)
